import React, { Component } from "react";
import { connect } from "react-redux";
import AddUserDialog from "../components/AddUserDialog";
import { WithStyles } from "@material-ui/core";
import { getUserById } from "../actions/userActions";
import { userStyles } from "../styles";

interface EditUserDialogProps extends WithStyles<typeof userStyles> {
  getUserById: any;
  match: any;
  user: any;
}
interface EditUserDialogState {
  userId: any;
}

class EditUserDialog extends Component<
  EditUserDialogProps,
  EditUserDialogState
> {
  constructor(props: EditUserDialogProps) {
    super();
    this.state = {
      userId: "",
    };
  }
  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const userId = params.userId;
    this.setState({
      userId: userId,
    });
    this.props.getUserById(userId);
  }
  render() {
    return <AddUserDialog user={this.props.user} isEdit={true} />;
  }
}

const mapStateToProps = (state: any) => ({
  user: state.clientManagement.usersManagement.user,
});

const mapDispatchToProps = {
  getUserById,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(EditUserDialog);
